import { ListItem, Switch } from '@lessonup/ui-components';
import React from 'react';

export interface ListItemSwitchSettingProps {
  id: string;
  text: string;
  ariaLabel: string;
  secondLine?: string;
  icon?: React.JSX.Element;
  /**
   * If provided, the switch will be uncontrolled, does not work together with checked.
   */
  defaultChecked?: boolean; // uncontrolled
  /**
   * If provided, the switch will be controlled, overrides defaultChecked.
   */
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

export const ListItemSwitchSetting: React.FC<ListItemSwitchSettingProps> = ({
  id,
  icon,
  text,
  ariaLabel,
  secondLine,
  defaultChecked = false,
  checked,
  disabled,
  onChange,
}) => {
  return (
    <ListItem
      text={text}
      secondLine={secondLine}
      icon={icon}
      endSlot={
        <Switch
          id={id}
          ariaLabel={ariaLabel}
          defaultChecked={defaultChecked}
          checked={checked}
          disabled={disabled}
          onChange={(event) => {
            onChange?.(event);
          }}
        />
      }
    />
  );
};
